import Vue from 'vue';
import { uploadBtnRenderType } from "@Views/Screening/utility/enums";

Vue.component('history-others', {
    template: `<div class="form-group row align-items-center ml-sm-2">
    <label class="col-sm-2 mb-sm-0">Others Start Date</label>
    <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
               type="date"
               v-model="othersObject.start_date"
               :max-date="othersObject.current_status ? new Date() : null"
               placeholder=""
    />
    <div class="error col-sm-8 offset-sm-2" v-if="validator && validator.start_date && !validator.start_date.isValidFromDate">
      From Date Can't Be Greater Than To Date.
    </div>
    <div class="w-100"></div>

    <label class="col-sm-2 mb-sm-0">Others End Date</label>
    <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
               type="date"
               v-model="othersObject.end_date"
               :disabled="othersObject.current_status"
               placeholder=""
    />

    <div class="form-group row align-items-center mt-2">
      <label class="col-sm-8">Currently Here?</label>
      <el-checkbox
          v-model="othersObject.current_status"
          @change="handleStatusChange"
      />
    </div>

    <label class="col-sm-2 mb-sm-0">More Information</label>
    <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
               type="textarea"
               v-model="othersObject.more_information"
               placeholder="Write some description"
    />

    <label class="col-sm-2 mb-sm-0">Please upload proof document.</label>
    <upload-btn :fileObj="othersObject.files"
                :renderType="type.CandidateDetail"
                :emailAddress="emailAddress"
                :metaData="othersObject"
                :auto-upload="false"
                @selected="onSelected"
    />

    <div
        v-if="localSelectedFiles.length"
        class="col-sm-12 document-preview-container mt-4"
        style="display:flex; flex-wrap:wrap; gap:20px; margin-top:10px; padding-left:15px; padding-right:15px;"
    >
      <div
          v-for="(file, index) in localSelectedFiles"
          :key="file.preview_key || file.id || file.file_path || file.file_name || index"
          class="document-preview-card"
          @click="viewFile(file.file_path)"
          style="cursor: pointer; display:flex; flex-direction:column; align-items:flex-start; width:auto;"
      >
        <div class="file-thumbnail-box" style="width:140px; height:100px; background:#fff; border:1px solid #e0e0e0; border-radius:10px; display:flex; align-items:center; justify-content:center; position:relative; overflow:hidden; box-shadow:0 4px 12px rgba(0,0,0,0.05);">
          <button
              class="remove-preview-btn"
              @click.stop="removePreviewFile(file, index)"
              style="position:absolute; top:6px; right:6px; width:22px; height:22px; border:none; border-radius:50%; background:#fff; color:#ff4d4f; box-shadow:0 1px 4px rgba(0,0,0,0.15); display:inline-flex; align-items:center; justify-content:center; cursor:pointer; z-index:2;"
          >
            <app-icon name="x" style="width: 14px; height: 14px;" />
          </button>

          <img v-if="isImage(file.file_name)"
               :src="getFileUrl(file.file_path)"
               alt="Document Preview"
               style="max-width:100%; max-height:100%; object-fit:cover;">

          <div v-else class="file-icon-large" style="color:#6c757d; width:48px; height:48px; display:flex; align-items:center; justify-content:center;">
            <app-icon :name="getFileIcon(file.file_name)" style="width: 48px; height: 48px;" />
          </div>
        </div>

        <div class="file-name-text" style="font-weight:600; margin-top:5px; font-size:14px; color:#3498db; max-width:140px; text-align:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
          {{ file.file_name }}
        </div>

        <div class="upload-status-badge" style="color:#27ae60; font-size:13px; display:flex; align-items:center; gap:4px; margin-top:6px; font-weight:600;">
          <template v-if="file.is_pending">
            <app-icon name="check-circle" style="width: 14px; height: 14px;" />
            Selected
            <app-icon name="check" style="width: 14px; height: 14px;" />
          </template>
          <template v-else>
            <app-icon name="check-circle" style="width: 14px; height: 14px;" />
            Uploaded
            <app-icon name="check" style="width: 14px; height: 14px;" />
          </template>
        </div>
      </div>
    </div>
    </div>`,

    props: {
        othersObject: {
            type: Object,
            required: true
        },
        emailAddress: {
            type: String
        },
        validator: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            type: uploadBtnRenderType,
            localSelectedFiles: this.mapUploadedFiles(this.othersObject.files)
        };
    },

    watch: {
        'othersObject.files': {
            handler(newFiles) {
                const uploadedFiles = this.mapUploadedFiles(newFiles);
                const pendingFiles = this.localSelectedFiles.filter(file => file.is_pending);

                this.localSelectedFiles = [...uploadedFiles, ...pendingFiles];
            },
            deep: true,
            immediate: true
        }
    },

    methods: {
        mapUploadedFiles(files) {
            if (!Array.isArray(files)) return [];

            return files.map((file, index) => ({
                id: file.id || file.file_id || file.document_id || null,
                file_name: file.file_name || file.name,
                file_path: file.path || file.file_path,
                is_pending: false,
                preview_key: `uploaded-${file.id || index}-${file.file_name || file.name || 'file'}`
            }));
        },

        onSelected(file) {
            const selectedFiles = Array.isArray(file) ? file : [file];

            const pendingFiles = selectedFiles.map((f, index) => ({
                raw_file: f,
                file_name: f.name,
                file_path: URL.createObjectURL(f),
                is_pending: true,
                preview_key: `pending-${Date.now()}-${index}-${f.name}`
            }));

            const existingPending = Array.isArray(this.othersObject.pending_files)
                ? this.othersObject.pending_files
                : [];

            this.$set(this.othersObject, 'pending_files', [...existingPending, ...selectedFiles]);
            this.localSelectedFiles = [...this.mapUploadedFiles(this.othersObject.files), ...pendingFiles];
        },

        async removePreviewFile(file, index) {
            if (!file) return;

            if (file.is_pending) {
                const pendingFiles = Array.isArray(this.othersObject.pending_files)
                    ? [...this.othersObject.pending_files]
                    : [];

                const pendingIndex = pendingFiles.findIndex(f => f && f.name === file.file_name);

                if (pendingIndex > -1) {
                    pendingFiles.splice(pendingIndex, 1);
                    this.$set(this.othersObject, 'pending_files', pendingFiles);
                }

                if (file.file_path && file.file_path.toString().startsWith('blob:')) {
                    URL.revokeObjectURL(file.file_path);
                }

                this.localSelectedFiles.splice(index, 1);
            } else {
                await this.removeFile(file, index);
            }
        },

        async removeFile(file, index) {
            try {
                if (!confirm('Are you sure you want to delete this document?')) return;

                const fid = file?.id || file?.file_id || file?.document_id || null;

                if (fid) {
                    await axios.delete(`/applicant-files/${fid}`);
                }
            } finally {
                if (Array.isArray(this.othersObject.files)) {
                    const uploadedIndex = this.othersObject.files.findIndex(item =>
                        (item.id || item.file_id || item.document_id || null) === (file.id || file.file_id || file.document_id || null)
                    );

                    if (uploadedIndex > -1) {
                        this.othersObject.files.splice(uploadedIndex, 1);
                    }
                }

                this.localSelectedFiles.splice(index, 1);
            }
        },

        getFileUrl(path) {
            if (!path) return '';

            const p = path.toString();

            if (p.startsWith('blob:') || p.startsWith('http')) return p;

            const normalized = p.startsWith('/') ? p : '/' + p;
            return window.location.origin + normalized;
        },

        viewFile(path) {
            const url = this.getFileUrl(path);
            if (url) window.open(url, '_blank');
        },

        isImage(fileName) {
            if (!fileName) return false;
            const ext = fileName.toString().split('.').pop().toLowerCase();
            return ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(ext);
        },

        getFileIcon(fileName) {
            if (!fileName) return 'file';

            const ext = fileName.toString().split('.').pop().toLowerCase();

            if (ext === 'pdf') return 'file-text';
            if (['doc', 'docx'].includes(ext)) return 'file-text';
            if (['xls', 'xlsx', 'csv'].includes(ext)) return 'file';
            return 'file';
        },

        handleStatusChange(checked) {
            if (checked) {
                const today = new Date().toISOString().split('T')[0];
                this.othersObject.end_date = today;
            } else {
                this.othersObject.end_date = '';
            }

            if (this.validator && this.validator.$touch) {
                this.validator.$touch();
            }

            this.$emit('status-change', checked);
        }
    }
});